import Layout from '@/components/layout/Layout.vue'
import { getTeamTargets } from '@/api/teamTarget'
import CreateForm from '@/views/sys/team/team-target/create/Create.vue'
import moment from 'moment'
import { deleteTeamTarget } from '../../../../api/teamTarget'
import { getUser } from '@/api/user'

export default {
    components: {
        Layout,
        moment,
        CreateForm
    },
    props: {
        showTeamTargetPage: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            data: [],
            pagination: { defaultPageSize: 20 },
            loading: false,
            columns: [
                { title: '月份', dataIndex: 'month' },
                { title: '消耗目标', dataIndex: 'target' },
                { title: '操作', dataIndex: '', scopedSlots: {customRender: 'action'} }
            ],
            queryParam: {},
            targetModel: {},
            showForm: false,
        }
    },
    created() {
        getUser().then(res => {
            this.$store.commit('setAdmin', res.data)
            if (this.accessTo('stat')) {
                this.columns.splice(2, 0, {
                    title: '月消耗',  customRender: item => {
                        if (!item.month_stat) {
                            return '-'
                        }
                        return item.month_stat.total_cost || '-'
                    }
                });
                this.columns.splice(3, 0, {
                    title: '月roi',  customRender: item => {
                        if (!item.month_stat) {
                            return '-'
                        }
                        let roi =  item.month_stat.total_cost > 0 && item.month_stat.total_income > 0 ? Number(item.month_stat.total_income / item.month_stat.total_cost * 100).toFixed(2) : '-'
                        return  !isNaN(roi) ? (roi >= 100 ? <span style="color:red">{roi}%</span> : <span style="color:green">{roi}%</span>) : '-'
                    }
                });
                // this.columns.splice(4, 0, {
                //     title: '月完成进度', customRender: row => {
                //         if (!row.month_stat) {
                //             return '-'
                //         }
                //         //本月消耗 / 本月目标
                //         let progress = row.month_stat.total_cost > 0 && row.target > 0 ? Number(row.month_stat.total_cost / row.target * 100).toFixed(2) : '-'
                //         return  !isNaN(progress) ? (progress >= 100 ? <span style="color:red">{progress}%</span> : <span style="color:green">{progress}%</span>) : '-'
                //     }
                // });
                this.columns.splice(4, 0, {  width:180,title: '本月完成进度', dataIndex: 'month_progress' , scopedSlots: { customRender: 'month_progress' } });
                this.columns.splice(5, 0, { title: '月度排名', dataIndex: 'month_rank' });
            }
        })
     
    },
    mounted() {
        this.getData()
    },
    methods: {
        handleTableChange(pagination) {
            const pager = { ...this.pagination }
            pager.current = pagination.current
            this.pagination = pager
            this.getData()
        },
        getData() {
            this.loading = true
            const pagination = { ...this.pagination }
            const json = Object.assign({}, this.queryParam, {
                page: pagination.current,
                page_size: pagination.defaultPageSize,
                team_id: this.model.team_id,
            })
            this.$helper.buildDateRangeParams(json, 'date')
            getTeamTargets(json).then(res => {
                pagination.total = res.data.total
                this.loading = false
                this.data = res.data.list
                this.pagination = pagination
            }).catch(() => {
                this.loading = false
            })
        },
        refresh() {
            this.getData()
            this.$emit('success')
        },
        search() {
            this.pagination.current = 1
            this.getData()
        },
        close() {
            this.$emit('update:showTeamTargetPage', false)
        },
        resetSearch() {
            this.queryParam = {}
            this.getData()
        },
        accessTo(route) {
            return this.$helper.accessTo('TeamTargetController', route)
        },
        addTarget(record) {
            let defaultData = { team_id: this.model.team_id, month: moment().format('YYYY-MM'), target: null, name: this.model.name}
            this.targetModel = record.id ? Object.assign({name: this.model.name}, record) : defaultData

            this.showForm = true
        },
        destroy(record) {
            const del = ids => {
                deleteTeamTarget(ids).then(res => {
                    this.$message.destroy()
                    if (res && res.code === 0) {
                        this.$message.success('删除成功')
                        this.refresh()
                    }
                })
            }
            if (!record) {
                return this.$confirm({
                    title: '操作提示',
                    centered: true,
                    content: () => <div style="color:red;">确定要删除选中的 {this.selectedRowKeys.length} 条数据吗?</div>,
                    onOk: () => {
                        del(this.selectedRowKeys)
                    }
                })
            }
            del([record.id])
        },
    }
}
